// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"38e56bc2","453":"8961ee31","455":"092e2de9","977":"415d9425"}[chunkId] + ".chunk.js";
};